import { render, staticRenderFns } from "./MdSwitch.vue?vue&type=template&id=1e1a5ab4&"
import script from "./MdSwitch.vue?vue&type=script&lang=js&"
export * from "./MdSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports